export const CP_PANEL_MAX_WIDTH_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_MAX_WIDTH_CHANGE'
export const CP_PANEL_WIDTH_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_WIDTH_CHANGE'
export const CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE'
export const CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE'
export const CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE'
export const CP_PANEL_IS_CUSTOMERS_ASC_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_IS_CUSTOMERS_ASC_CHANGE'



// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/actionTypes.js